import React, { ReactNode } from "react";
import { Chart, Legend, LinearScale, PointElement, Tooltip } from "chart.js";
import DataLabels from "chartjs-plugin-datalabels";
import { Bubble } from "react-chartjs-2";
import styled from "styled-components";
import { useTheme } from "@glossy/theme";
import { Locale } from "@linkfluence/models/locale";
import { Metric } from "@linkfluence/models/metric";
import { BubbleSerie as Serie } from "../models";
import { useData } from "./data";
import { useOnClickPoint, useOptions } from "./options";

Chart.register(LinearScale, PointElement, Tooltip, Legend, DataLabels);

type ChartTooltip = {
  label: string;
  color: string;
  size: number;
  xValue: number;
  yValue: number;
};
interface Props {
  series: Serie[];
  locale: Locale;
  XMetricLabel: string;
  YMetricLabel: string;
  sizeMetricLabel?: string;
  XMetric: Metric;
  chartTooltip?: (props: ChartTooltip) => ReactNode;
  className?: string;
  onClickPoint?: (serie: Serie["id"]) => void;
  scaleX?: "linear" | "logarithmic";
  scaleY?: "linear" | "logarithmic";
  disableAnimation?: boolean;
  isFullscreen?: boolean;
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const BubbleChart = ({
  series,
  locale,
  XMetricLabel,
  YMetricLabel,
  sizeMetricLabel,
  XMetric,
  className,
  chartTooltip,
  onClickPoint,
  scaleX = "linear",
  scaleY = "linear",
  disableAnimation = false,
  isFullscreen,
}: Props) => {
  const theme = useTheme();
  const datasets = useData(series, theme);
  const onClick = useOnClickPoint(series, onClickPoint);
  const options = useOptions(
    theme,
    locale,
    XMetricLabel,
    YMetricLabel,
    sizeMetricLabel,
    XMetric,
    onClickPoint ? onClick : null,
    series,
    chartTooltip,
    scaleX,
    scaleY,
    disableAnimation,
    isFullscreen
  );

  return (
    <Root className={className}>
      <Bubble data={{ datasets }} options={options} />
    </Root>
  );
};

export default BubbleChart;
